import React from "react";
import { View, Text, Button, TextInput } from "ui";
import { styled } from "styles";
import { Checkbox } from "@material-ui/core";
import { authMutations } from "api";
import { notify } from "../shared/services/notify";

export default class SignUp extends React.Component {
  public state = {
    phone: "",
    checked: false
  };

  public handleCheck = () => {
    this.setState({ checked: !this.state.checked });
  }

  public render = () => {
    return (
      <View px={5} my={5} flexDirection="column" alignItems="center">
        <authMutations.SignUpMutation>
          {signUp => (
            <SignupInput
              onSubmit={async e => {
                e.preventDefault();
                try {
                  if (!this.state.checked) {
                    alert("Termeni si conditii.");
                    return;
                  }
                  const phoneNumber = this.state.phone;
                  await signUp({
                    variables: { phoneNumber, countryId: 1 }
                  });
                  notify("Contul a fost creat!");
                } catch (err) {}
              }}
            >
              <View
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
              >
                <TextInput
                  alignSelf="stretch"
                  placeholder="Telefon"
                  onChange={e => this.setState({ phone: e.target.value })}
                />
                <Button
                  p={2}
                  mt={2}
                  color="primary"
                  alignSelf="stretch"
                  as="button"
                  type="submit"
                  border="none"
                >
                  <Text fontSize={4} fontWeight="bold" color="white">
                    Creeaza cont
                  </Text>
                </Button>
              </View>
            </SignupInput>
          )}
        </authMutations.SignUpMutation>

        <View
          mt={2}
          flexDirection="row"
          alignItems="center"
          alignSelf="flex-start"
          onClick={this.handleCheck}
        >
          <Checkbox color="default" checked={this.state.checked} />
          <CheckBoxText fontSize={4}>
            Sunt de acord cu Termenii si Conditiile.
          </CheckBoxText>
        </View>
      </View>
    );
  }
}

const CheckBoxText = styled(Text)`
  cursor: pointer;
`;

const SignupInput = styled.form`
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/pages/Signup.tsx